import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function NavigateBackFromIframe() {
    const navigate = useNavigate();

    useEffect(() => {
        const handleMessage = (e) => {
            const shouldNavigateBack = e.data?.navigateBack === 'yes';

            if (shouldNavigateBack) {
                navigate('/guides');
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []); 

    return null;
}